import styled from 'styled-components';

export const GuestTestimonyCard = ({
    avatarUrl,
    avatarAlt = 'Foto de perfil',
    name,
    location,
    subtitle,
    role,
    testimony,
}) => {
    return (
        <GuestTestimonyCardWrapper>
            <TestimonyCardHeader>
                <TestimonyCardAvatar>
                    <img
                        src={
                            avatarUrl ||
                            'https://www.aden.org/images/default_avatar.png'
                        }
                        alt={avatarAlt}
                    />
                </TestimonyCardAvatar>
                <TestimonyCardInfo>
                    <TestimonyCardName>
                        {name}
                        {location && ` - ${location}`}
                    </TestimonyCardName>
                    <TestimonyCardSubtitle>{subtitle}</TestimonyCardSubtitle>
                    <TestimonyCardPosition>{role}</TestimonyCardPosition>
                </TestimonyCardInfo>
            </TestimonyCardHeader>
            <TestimonyCardQuote>
                <p>"{testimony}"</p>
            </TestimonyCardQuote>
        </GuestTestimonyCardWrapper>
    );
};

const GuestTestimonyCardWrapper = styled.div`
    background: #ffffff;
    border-radius: 20px;
    padding: 2.5rem;
    max-width: 1120px;
    width: 100%;
    min-height: 320px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    @media (max-width: 640px) {
        padding: 1.5rem;
        border-radius: 16px;
        min-height: 280px;
    }
`;

const TestimonyCardHeader = styled.div`
    display: flex;
    gap: 1.5rem;
    align-items: flex-start;
    margin-bottom: 2rem;

    @media (max-width: 640px) {
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 1rem;
    }
`;

const TestimonyCardAvatar = styled.div`
    flex-shrink: 0;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    background-color: #f5f5f5;
    border: 3px solid #ffffff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }

    @media (max-width: 640px) {
        width: 80px;
        height: 80px;
    }
`;

const TestimonyCardInfo = styled.div`
    flex: 1;
    padding-top: 0.25rem;
`;

const TestimonyCardName = styled.div`
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.3;
    color: #171717;
    margin: 0 0 0.5rem 0;
    letter-spacing: -0.01em;

    @media (max-width: 640px) {
        font-size: 1.25rem;
    }
`;

const TestimonyCardSubtitle = styled.div`
    font-size: 1rem;
    line-height: 1.5;
    color: #525252;
    margin: 0 0 0.25rem 0;

    @media (max-width: 640px) {
        font-size: 0.9375rem;
    }
`;

const TestimonyCardPosition = styled.div`
    font-size: 1rem;
    line-height: 1.5;
    color: #171717;
    margin: 0;

    @media (max-width: 640px) {
        font-size: 0.9375rem;
    }
`;

const TestimonyCardQuote = styled.div`
    margin: 0;
    padding: 0;
    max-height: 180px;
    overflow: hidden;

    p {
        font-size: 1rem;
        line-height: 1.6;
        color: #404040;
        font-style: italic;
        margin: 0;
        letter-spacing: 0.01em;
        display: -webkit-box;
        -webkit-line-clamp: 7;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    @media (max-width: 640px) {
        max-height: 150px;

        p {
            font-size: 0.9375rem;
            -webkit-line-clamp: 6;
        }
    }
`;
